import { number, object, string } from 'yup';

import { getMaxLengthErrMsg, validationErrMessages } from '@constants/validationConstants';
import { MAX_DESCRIPTION_LENGTH } from '@constants/validationMessages';

export const schema = object({
	assetDbId: object().nullable().required(validationErrMessages.assetId),
	from: number()
		.nullable()
		.required(validationErrMessages.rentalPeriodFrom),
	to: number()
		.nullable()
		.required(validationErrMessages.rentalPeriodTo),
	comment: string()
		.nullable()
		.max(MAX_DESCRIPTION_LENGTH, getMaxLengthErrMsg('Comment', MAX_DESCRIPTION_LENGTH)),
});
